export default {
    currentPage(state) {
        return state.currentPage;
    },
    lastPage(state) {
        return state.lastPage;
    },
    itemsPerPage(state) {
        return state.itemsPerPage;
    },
    pageOptions(state) {
        return state.pageOptions;
    }
};
